import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InputMask } from '@react-input/mask';
import Select from 'react-select';
import FileDropzone from './FileDropzone';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';
import 'moment/locale/pt';
import { useToken } from '../TokenContext';

export const FormEditParticipante = () => {
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [states, setStates] = useState([]);
    const [lojasSelect, setLojasSelect] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [participanteData, setParticipanteData] = useState({
        cnpj: '',
        nome: '',
        email: '',
        nascimento: '',
        rg: '',
        cpf: '',
        fone: '',
        password: '',
        password_confirmation: '',
        funcao: '',
        ativo: '',
        razao: '',
        endereco: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        estabelecimento_id: '',
    });

    const [participanteErrorData, setParticipanteErrorData] = useState({
        cnpj: [],
        nome: [],
        email: [],
        nascimento: [],
        rg: [],
        cpf: [],
        fone: [],
        password: [],
        password_confirmation: [],
        funcao: [],
        ativo: [],
        estabelecimento_id: [],
    });

    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState('');

    const executedRef = useRef(false);
    
    const selectOptions = [
        { value: 'representante', label: 'Representante' },
        { value: 'gerente', label: 'Gerente' },
    ];
    
    const { tokenData } = useToken();
    const navigate = useNavigate();
    const { id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchParticipante = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/participantes/editar/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
               setError('Erro ao buscar os dados do prêmio.');
            }

            const data = await response.json();
            console.log(data)
            setParticipanteData(data.participante);

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchStates = async () => {
        try {
            const response = await fetch(`${baseUrl}/estados`, {
                method: 'GET',
            });

            if (!response.ok) {
                setError('Erro ao buscar os destinos.');
            }

            const data = await response.json();

            setStates(data.estados.map(state => ({
                value: state.uf,
                label: `${state.nome} - ${state.uf}`,
            })));

        } catch (error) {
            setError(error.message);
        } 
    };

    const fetchLojas = async () => {
        try {
            const response = await fetch(`${baseUrl}/lojas`, {
                method: 'GET',
            });

            if (!response.ok) {
               setError('Erro ao buscar as lojas.');
               return;
            }

            const data = await response.json();
            setLojas(data.lojas);
            setLojasSelect(data.lojas.map(loja => ({
                value: loja.id,
                label: `${loja.nome} - ${loja.cnpj}`, 
            })));

        } catch (error) {
            setError(error.message);
        } 
    };

    
    useEffect(() => {
        fetchStates();
        fetchParticipante();
        fetchLojas();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setParticipanteData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSelectChange = (name, selectedOption) => {
        setParticipanteData(prevData => ({
            ...prevData,
            [name]: selectedOption.value
        }));

        if (name === "estabelecimento_id") {
            const estabelecimentoSelecionado = lojas.find((opt) => opt.id == selectedOption.value);
    
            if (estabelecimentoSelecionado) { 
                setParticipanteData(prevData => ({
                    ...prevData,
                    razao: estabelecimentoSelecionado.razao,
                    cnpj: estabelecimentoSelecionado.cnpj,
                }));
            }
        }
    };
   
    const handleSubmit = async (e) => {
        
        e.preventDefault();
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/participantes/editar/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(participanteData)
            });
            const result = await response.json();

            if (!response.ok) {
                setFormLoading(false);
                setParticipanteErrorData(result);
                setError('Erro ao editar o participante');
              
                navigate(`/manager/participantes/editar/${id}`, {
                    state: {
                        message: { type: 'error', text: result.message ?? 'Por favor, verifique o(s) campo(s) sinalizados em vermelho.' },
                    },
                });
                return;
            }

            setFormLoading(false);
            navigate(`/manager/participantes/editar/${id}`, {
                state: {
                    message: { type: 'success', text: result.message },
                },
            });
            
        } catch (error) {
            setFormLoading(false);
            setError(error.message);
        }
    };


    if (loading) return (
        <div className="mx-auto py-10">
            <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
        </div>
    );

    return (
        <>
            <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                 <div className="mb-6 2xl:mb-10">
                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Loja</label>
                            <Select
                                name="estabelecimento_id"
                                options={lojasSelect}
                                value={lojasSelect.find(option => option.value == participanteData.estabelecimento_id) || null}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, estabelecimento_id: []}))}
                                onChange={selectedOption => handleSelectChange('estabelecimento_id', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select"
                            />
                            {participanteErrorData.estabelecimento_id && participanteErrorData.estabelecimento_id[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.estabelecimento_id[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, estabelecimento_id: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>
                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">CNPJ</label>
                            <InputMask
                                type="text"
                                name="cnpj"
                                mask="__.___.___/____-__"
                                replacement={{ _: /\d/ }}
                                value={participanteData.cnpj}
                                onClick={() => setParticipanteErrorData(prevData => ({ ...prevData, cnpj: [] }))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {participanteErrorData.cnpj && participanteErrorData.cnpj[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.cnpj[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, cnpj: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Razão social</label>
                            <input
                                type="text"
                                name="razao"
                                value={participanteData.razao}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, razao: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.razao && participanteErrorData.razao[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.razao[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, razao: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                       
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Nome</label>
                            <input
                                type="text"
                                name="nome"
                                value={participanteData.nome}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, nome: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.nome && participanteErrorData.nome[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.nome[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, nome: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">E-mail</label>
                            <input
                                type="text"
                                name="email"
                                value={participanteData.email}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, email: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.email && participanteErrorData.email[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.email[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, email: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">RG</label>
                            <input
                                type="text"
                                name="rg"
                                value={participanteData.rg}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, rg: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.rg && participanteErrorData.rg[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.rg[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, rg: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">CPF</label>
                            <InputMask
                                type="text"
                                name="cpf"
                                mask="___.___.___-__"
                                replacement={{ _: /\d/ }}
                                value={participanteData.cpf}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, cpf: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {participanteErrorData.cpf && participanteErrorData.cpf[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.cpf[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, cpf: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Telefone</label>
                            <InputMask
                                type="text"
                                name="fone"
                                mask="(__) _____-____"
                                replacement={{ _: /\d/ }}
                                value={participanteData.fone}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, fone: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {participanteErrorData.fone && participanteErrorData.fone[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.fone[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, fone: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Data de nascimento</label>
                            <input
                                type="date"
                                name="nascimento"
                                value={participanteData.nascimento}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, nascimento: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.nascimento && participanteErrorData.nascimento[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.nascimento[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, nascimento: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Senha</label>
                            <input
                                type="password"
                                name="password"
                                value={participanteData.password}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, password: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.password && participanteErrorData.password[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.password[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, password: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Confirmar senha</label>
                            <input
                                type="password"
                                name="password_confirmation"
                                value={participanteData.password_confirmation}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, password_confirmation: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.password_confirmation && participanteErrorData.password_confirmation[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.password_confirmation[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, password_confirmation: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">CEP</label>
                            <InputMask
                                type="text"
                                name="cep"
                                mask="_____-___."
                                replacement={{ _: /\d/ }}
                                value={participanteData.cep}
                                onClick={() => setParticipanteErrorData(prevData => ({ ...prevData, cep: [] }))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {participanteErrorData.cep && participanteErrorData.cep[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.cep[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, cep: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Cidade</label>
                            <input
                                type="text"
                                name="cidade"
                                value={participanteData.cidade}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, cidade: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.cidade && participanteErrorData.cidade[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.cidade[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, cidade: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Endereço</label>
                            <input
                                type="text"
                                name="endereco"
                                value={participanteData.endereco}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, endereco: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.endereco && participanteErrorData.endereco[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.endereco[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, endereco: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Bairro</label>
                            <input
                                type="text"
                                name="bairro"
                                value={participanteData.bairro}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, bairro: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {participanteErrorData.bairro && participanteErrorData.bairro[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.bairro[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, bairro: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Estado</label>
                            <Select
                                name="estado"
                                options={states}
                                value={states.find(option => option.value == participanteData.estado) || null}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, estado: []}))}
                                onChange={selectedOption => handleSelectChange('estado', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select"
                            />

                            {participanteErrorData.estado && participanteErrorData.estado[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.estado[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, estado: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Função</label>
                            <Select
                                name="funcao"
                                options={selectOptions}
                                value={selectOptions.find(option => option.value === participanteData.funcao) || null}
                                onClick={() => setParticipanteErrorData(prevData => ({...prevData, funcao: []}))}
                                onChange={selectedOption => handleSelectChange('funcao', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select"
                            />
                            {participanteErrorData.funcao && participanteErrorData.funcao[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.funcao[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, funcao: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-fit">
                            <label className="block text-sm font-medium mb-3">Ativo</label>
                            <label className="cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="ativo"
                                    checked={participanteData.ativo} 
                                    onChange={handleChange}
                                    className="sr-only peer"
                                />
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 peer-focus:ring-0 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                            </label>

                            {participanteErrorData.ativo && participanteErrorData.ativo[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{participanteErrorData.ativo[0]} <span onClick={() => setParticipanteErrorData(prevData => ({...prevData, ativo: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>
                </div>

                <button
                    type="submit"
                    className="w-full bg-primary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    
                >
                    {!formLoading ? (
                        'Salvar'
                    ) : (
                        <div role="status" className="flex justify-center items-center">
                            <svg aria-hidden="true" className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg>
                            <span className="sr-only">Loading...</span>
                        </div>
                    )}
                </button>
            </form>
        </>
    );
}
